import { QueryOperation, SearchQuery } from "../code/search-query/search-query";
import { DataColumn } from "../controls/Data.default";
import {
  buildSearchQuery,
  QueryFieldMapping,
} from "../code/search-query/query-mapper";

export interface LanguagesForm {
  readonly uid?: string;
  readonly rowVersion?: string;
  readonly name: string;
  readonly code: string;
  readonly alpha3Code?: string;
  readonly isTestLanguage?: boolean;
}

export const languagesViewColumns: DataColumn[] = [
  {
    title: "Name",
    key: "name",
    width: 220,
    sort: true,
    defaultSort: "asc",
    fixed: "left",
  },
  {
    title: "Code",
    key: "code",
    width: 120,
    sort: true,
  },
  {
    title: "Alpha-3 Code",
    key: "alpha3Code",
    width: 140,
    sort: true,
  },
  {
    title: "Test Language",
    key: "isTestLanguage",
    width: 140,
    sort: true,
    transform: (value: boolean) => (value ? "Yes" : "No"),
  },
  {
    title: "Created On",
    key: "createdOn",
    width: 168,
    sort: true,
    format: "DD/MM/YYYY HH:mm",
  },
  {
    title: "Updated On",
    key: "updatedOn",
    width: 168,
    sort: true,
    format: "DD/MM/YYYY HH:mm",
  },
];

const languagesQueryMappings: QueryFieldMapping[] = [
  { formField: "name", operation: QueryOperation.StartsWith },
  { formField: "code", operation: QueryOperation.StartsWith },
  { formField: "alpha3Code", operation: QueryOperation.StartsWith },
];

export const mapLanguagesViewQuery = (values: LanguagesForm): SearchQuery =>
  buildSearchQuery(values, languagesQueryMappings);
